export const currentUser = ({ currentUser }) => currentUser
export const editUserDialog = ({ editUserDialog }) => editUserDialog
